import { render, staticRenderFns } from "./StoreProductsInBin.vue?vue&type=template&id=7cee212c"
import script from "./StoreProductsInBin.vue?vue&type=script&lang=js"
export * from "./StoreProductsInBin.vue?vue&type=script&lang=js"
import style0 from "./StoreProductsInBin.vue?vue&type=style&index=0&id=7cee212c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports